import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface FilePackageStore {
  // Packages this user generated that are still being built.
  pendingIds: string[];
  // The file (service) each pending package was generated from, keyed by
  // package id, so the maintenance page can show that row as in progress.
  serviceIds: Record<string, string>;
  track: (filePackageId: string, serviceId: string) => void;
  untrack: (filePackageIds: string[]) => void;
  reset: () => void;
}

// sessionStorage, not localStorage: it survives a reload of this tab, and
// writing it doesn't fire the cross-tab `storage` event that makes Template
// reload every other open tab.
export const useFilePackageStore = create<FilePackageStore>()(
  persist(
    (set) => ({
      pendingIds: [],
      serviceIds: {},
      track: (filePackageId, serviceId) =>
        set((state) => ({
          pendingIds: state.pendingIds.includes(filePackageId) ? state.pendingIds : [...state.pendingIds, filePackageId],
          serviceIds: { ...state.serviceIds, [filePackageId]: serviceId },
        })),
      untrack: (filePackageIds) =>
        set((state) => ({
          pendingIds: state.pendingIds.filter((id) => !filePackageIds.includes(id)),
          serviceIds: Object.fromEntries(
            Object.entries(state.serviceIds).filter(([id]) => !filePackageIds.includes(id))
          ),
        })),
      reset: () => set({ pendingIds: [], serviceIds: {} }),
    }),
    {
      name: 'file-package-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
